var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"important-message-text",attrs:{"id":"important-message"}},_vm._l((_vm.alertTemplates),function(alert){return _c('div',[_c({template: alert},{tag:"component"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }